<style>
.instruction-box {
  background-color: #fff7f7;
  border: 1px solid #f2c2c2;
  border-radius: 8px;
  text-align: center;
}

.note-text {
  color: #6b0000;
  font-size: 14px;
}
</style>


<style scoped>
/*  Medium screens (laptops, landscape tablets) — use 70% layout */
@media (max-width: 1920px) and (max-height: 1080px),
       (max-width: 1600px) and (max-height: 900px),
       (max-width: 1440px),
       (max-width: 1366px),
       (max-width: 1280px),
       (max-width: 1180px) and (orientation: landscape),
       (max-width: 1024px) and (orientation: landscape) {
  .side_bar {
    display: none !important;
  }
  .slot_section {
    flex: 0 0 70% !important;
    max-width: 100% !important;
  }
}

/* 📱 Small devices (mobiles & tablets portrait) — use full 100% layout */
@media (max-width: 1024px) and (orientation: portrait),
       (max-width: 912px),
       (max-width: 834px),
       (max-width: 820px),
       (max-width: 768px),
       (max-width: 640px),
       (max-width: 540px),
       (max-width: 430px),
       (max-width: 414px),
       (max-width: 393px),
       (max-width: 384px),
       (max-width: 375px),
       (max-width: 360px) {
  .side_bar {
    display: none !important;
  }
  .slot_section {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
@media (min-width: 1024px) and (max-width: 1366px) {
  .side_bar { display: none !important; }
  .slot_section { flex: 0 0 70% !important; max-width: 100% !important; }
}
</style>
<template>
    <div class="col-lg-9 col-md-8 slot_section p-lg-5 p-4">
      <div class="container">
        <h5>03. Invoice Summary</h5>
        <p>Review your summary for Slot Booking charge <b style="color: black;">( Non-Refundable )</b>, then continue with the payment process.</p>
        <div class="invoice-box">
            <!-- Slot Date Header -->
            <div class="invoice-header py-4 px-3" style="color: rgb(171 14 14) !important;">
              Slot Date: 
              <span class="fw-normal">
                {{ selectedSlotData ? formatDate(selectedSlotData.start_Date) : '-' }}
              </span>
            </div>
    
            <!-- Booking Details -->
            <div class="row invoice-item px-3 mt-3">
              <div class="col-6 py-1">
                <i class="fa-regular fa-clock me-2"></i>Booked on
              </div>
              <div class="col-6 text-end">
                {{ formatDate(new Date()) }}
              </div>
            </div>
    
            <div class="row invoice-item mt-2 px-3">
              <div class="col-6">
                <i class="fa-regular fa-clock me-2"></i>Slot Time
              </div>
              <div class="col-6 text-end">
                {{ selectedSlotData ? formatTimeRange(selectedSlotData.start_time, selectedSlotData.end_time) : '-' }}
              </div>
            </div>
    
            <hr>
    
            <!-- Pricing Details -->
            <div class="row invoice-item px-3 mt-3">
              <div class="col-6">
                <i class="fa-solid fa-person me-2"></i>Adult
              </div>
              <div class="col-6 text-end">
                ₹ {{ selectedSlotData ? selectedSlotData.entity_price : 0 }}<br>
                <small class="text-muted">Count: {{ noOfAdults }}</small>
              </div>
            </div>
    
            <!-- Children Pricing (conditionally shown) -->
            <div v-if="noOfChildren > 0">
              <div class="row invoice-item px-3">
                <div class="col-6">
                  <i class="fa-solid fa-child me-2"></i>Children
                </div>
                <div class="col-6 text-end">
                  ₹ {{ selectedSlotData ? selectedSlotData.entity_price : 0 }}<br>
                  <small class="text-muted">Count: {{ noOfChildren }}</small>
                </div>
              </div>
            </div>
    
            <hr class="mb-0">
    
            <!-- Total Amount -->
            <div class="row invoice-total py-3 px-2 px-lg-3" style="color: rgb(171 14 14) !important;">
              <div class="col-6 mb-0">Slot Booking Charge(Non-Refundable)</div>
              <div class="col-6 text-end">
                Total : ₹ {{ calculateTotal() }}
              </div>
            </div>

            <!-- <hr class="mb-0"> -->

            <!-- Instruction Section -->
            <div class="instruction-box py-3 px-3 mt-2 d-flex align-items-center justify-content-center text-center">
              <p class="note-text mb-0">
                <i class="fa-solid fa-triangle-exclamation me-2" style="color: #ab0e0e !important;"></i>
                <i class="fa-solid fa-credit-card me-2" style="color: #ab0e0e;"></i>
                Please ensure that your card is enabled for <b>online (E-commerce)</b> transactions.
              </p>
            </div>


        </div>
      </div>
  
      <!-- Continue Button -->
      <div class="row mt-lg-5 pt-lg-2 pt-2">
        <div class="col-12 col-lg-9 text-center">
          <a href="#" class="btn continue-btn w-50 px-4 py-2" :disabled="loading" @click="handleContinue">
            <span v-if="loading"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
            <span v-else>Continue</span>
          </a>
        </div>  
      </div>


      <VerifyEmailAddressModel v-if="showVerifyEmailModal" @backToSummary="goBackToPaymentSummary" @backStep="emitBackStep" />


    </div>
  </template>
  
  <script>
  import VerifyEmailAddressModel from '@/components/Booking/ApplicationForms/models/verifyEmail.vue';
  import 'bootstrap/dist/js/bootstrap.bundle.min.js';
  import FormPage from '@/components/Booking/ApplicationForms/Form.vue';

  export default {
    name: "PaymentSummary",
    components: {
        VerifyEmailAddressModel, FormPage
    },
    data() {
      return {
        selectedSlotData: null,
        noOfAdults: null,
        noOfChildren: 0,
        showVerifyEmailModal: false,
        loading: false,
      };
    },
    mounted() {
      const savedSlot = localStorage.getItem("selectedSlot");
      const applicantData = localStorage.getItem("bookingData");
  
      if (savedSlot) {
        this.selectedSlotData = JSON.parse(savedSlot);
        ///console.log("Selected Slot Data:", this.selectedSlotData)
      }
  
      if (applicantData) {
        const applicant = JSON.parse(applicantData);
        this.noOfAdults = applicant.noOfAdult || 0;
        this.noOfChildren = applicant.noOfChildren || 0;
      }

      // REMOVE ANY MODAL BACKDROP LEFTOVER
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    },
    methods: {
      formatDate(dateInput) {
        const date = new Date(dateInput);
        return isNaN(date.getTime()) ? '-' : date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      },
  
      formatTimeRange(start, end) {
        const startTime = this.formatTime(start);
        const endTime = this.formatTime(end);
        return `${startTime} - ${endTime}`;
      },
  
      formatTime(time) {
        const timeRegex = /(\d{1,2}):(\d{2})\s([APM]{2})/i;
        const matches = time.match(timeRegex);

        if (matches) {
            const hours = parseInt(matches[1], 10);
            const minutes = parseInt(matches[2], 10);
            const period = matches[3].toUpperCase(); // AM/PM

            let hourIn24 = hours;
            if (period === "PM" && hours !== 12) {
            hourIn24 += 12;
            }
            if (period === "AM" && hours === 12) {
            hourIn24 = 0;
            }

            const date = new Date();
            date.setHours(hourIn24, minutes, 0, 0); 
            return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
        }

        console.error(`Invalid time provided: ${time}`);
        return 'Invalid Time';
      },

  
      calculateTotal() {
        const slotPrice = this.selectedSlotData ? this.selectedSlotData.entity_price : 0;
        return slotPrice * (this.noOfAdults + this.noOfChildren);
      },
  
      async handleContinue() {
        this.loading = true;
        //await new Promise(resolve => setTimeout(resolve, 1000));
        this.showVerifyEmailModal = true;
        ///console.log('Proceeding to next step...');
        const modalEl = document.getElementById('emailApplicantModal');
        if (modalEl) {
            const bootstrapModal = new bootstrap.Modal(modalEl);
            bootstrapModal.show();
           //this.$emit("nextStep");
        } else {
            //console.error("Modal element not found!");
        }
        this.loading = false;
      },

      goBackToPaymentSummary(formData) {
          this.showVerifyEmailModal = false;
          
          this.$emit("nextStep");
          this.$emit("nextStep");
          ///console.log("Received Form Number Response Data:", formData);
          this.$toast.success('Payment successful completed.', {
            position: 'top-right',
            duration: 3000,
          });
      },

      emitBackStep() {
        //console.log(' PaymentSummary re-emitting backStep');
        //this.$emit('backStep');   // ← forward to BookingHomePage
        setTimeout(() => {this.$emit('backStep');}, 500);
      },

    },
  };
  </script>
  